import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultSchemeData, getSchemeById, updateScheme, createScheme } from '@/api/schemes';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import FileUpload from '@/components/FileUpload/index.vue';
import { getBranches } from '@/api/locations/branches';
import { getStates } from '@/api/locations/states';
import { getQuery } from '@/utils';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultSchemeData);
    this.loading = false;
    this.validity = [];
    this.image = [];
    this.branchList = [];
    this.stateList = [];
    this.targetBranchIds = [];
    this.targetStateIds = [];
    this.rules = {
      name: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    this.targetBranchIds = [];
    this.targetStateIds = [];
    this.fetchTargets();
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultSchemeData);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  branchLabel(branch) {
    return branch.code || branch.name;
  }
  async fetchTargets() {
    const params = () => getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    });
    this.branchList = await getBranches(params());
    this.stateList = await getStates(params());
  }
  async fetchData(id) {
    try {
      const data = await getSchemeById(id);
      if (data.startDate && data.endDate) {
        this.validity = [new Date(data.startDate), new Date(data.endDate)];
      }
      this.formData = data;
      this.targetBranchIds = (data.targetBranches || []).map(b => b.id);
      this.targetStateIds = (data.targetStates || []).map(s => s.id);
      this.image.push({
        name: data.name,
        url: data.image
      });
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  imageUploaded(file) {
    this.formData.image = file.response;
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      this.formData.startDate = this.$moment(this.validity[0]).format('YYYY-MM-DD');
      this.formData.endDate = this.$moment(this.validity[1]).format('YYYY-MM-DD');
      // targeting only applies to mobile schemes
      this.formData.targetBranches = this.formData.forMobile ? this.targetBranchIds.map(id => ({
        id
      })) : [];
      this.formData.targetStates = this.formData.forMobile ? this.targetStateIds.map(id => ({
        id
      })) : [];
      if (this.isEdit) {
        await updateScheme(this.formData.id, this.formData);
      } else {
        await createScheme(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Scheme saved',
        type: 'success',
        duration: 2000
      });
      router.push('/schemes/list');
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'SchemeDetail',
  components: {
    FileUpload
  }
})], default_1);
export default default_1;